import moment from "moment";
import { GmailThread } from "schemas/dashboard";
import { EmailDraft } from "schemas/email";

import { isInvalidEmail } from "utils/string";

export const generateDefaultTime = (gmailThread: GmailThread) => {
  let lastEmailDate =
    gmailThread.messages[gmailThread.messages.length - 1].date;
  for (const message of gmailThread.messages) {
    if (!message.is_sent_by_user) {
      lastEmailDate = message.date;
    }
  }
  if (!lastEmailDate) {
    return moment().startOf("hour").add(1, "hour");
  }
  const momentDate = moment(lastEmailDate, "ddd, DD MMM YYYY HH:mm:ss Z");
  const tomorrowDate = moment().add(1, "days");
  tomorrowDate.set({
    hour: momentDate.hour(),
    minute: 0,
    second: 0,
  });
  if (momentDate.minute() >= 30) {
    tomorrowDate.add(1, "hour");
  }
  return tomorrowDate;
};

export const getTomorrow = () => {
  const tomorrowDate = moment().add(1, "days");
  tomorrowDate.set({
    hour: tomorrowDate.hour(),
    minute: 0,
    second: 0,
  });
  if (tomorrowDate.minute() >= 30) {
    tomorrowDate.add(1, "hour");
  }
  return tomorrowDate;
};

export const hasInvalidEmail = (emailDraft: EmailDraft) => {
  for (const contact of emailDraft.ccContacts) {
    if (
      contact?.email &&
      contact?.email?.trim()?.length > 0 &&
      isInvalidEmail(contact.email)
    ) {
      return true;
    }
  }
  for (const contact of emailDraft.toContacts) {
    if (
      contact?.email &&
      contact?.email?.trim()?.length > 0 &&
      isInvalidEmail(contact.email)
    ) {
      return true;
    }
  }
  return false;
};
